// * Import 3rd party
import { styled } from "@mui/material/styles";
import { AgGridReact } from "ag-grid-react";

const StyledAgGridReact = styled(AgGridReact)(({ theme }) => {
  return {
    "& .ag-header-row": {
      background: theme.palette.table.background,
      borderBottom: `1px solid ${theme.palette.grey[1]}`,
      fontFamily: theme.typography.fontFamily,
    },
    "& .ag-header-cell-text": {
      color: theme.palette.table.heading,
      fontWeight: theme.fontWeight[600],
      fontSize: theme.size[12],
      textTransform: "uppercase",
      fontFamily: theme.typography.fontFamily,
    },
    "& .ag-root-wrapper.ag-layout-normal": {
      background: theme.palette.lineage.background,
      borderRadius: "12px",
    },
    "& .ag-row-hover:not(.ag-full-width-row)::before, .ag-row-hover.ag-full-width-row.ag-row-group::before":
      {
        background: `${theme.palette.table.rowHoverColor} !important`,
      },
    "& .ag-paging-button, .ag-paging-description, & .ag-icon, & .ag-icon-last-left, & .ag-paging-panel > * ":
      {
        color: theme.palette.table.heading,
      },
    "& .ag-icon-menu": {
      color: theme.palette.table.heading,
    },
    "& .ag-icon-menu:hover": {
      color: theme.palette.table.heading,
    },
    "& .ag-header": {
      position: "sticky",
      top: 0,
      // zIndex: 1,
    },
    "& .ag-row": {
      // background: theme.palette.table.background,
      background: "transparent",
    },
    "& .ag-row:nth-child(even)": {
      background: theme.palette.table.rowBgColor,
    },
    "& .MuiInput-input.Mui-disabled": {
      WebkitTextFillColor: theme.palette.cards.heading,
      opacity: 0.5,
    },
    "& .ag-select, .ag-picker-field-display, .ag-text-field-input": {
      fontFamily: "Noto Sans",
    },
    "& .ag-header-cell-comp-wrapper": {
      color: theme.palette.table.heading,
    },
    "& .ag-cell-inline-editing": {
      padding: "0px",
    },
    "& .ag-cell-focus": {
      borderColor: "transparent !important",
    },
    "& .ag-floating-bottom": {
      fontWeight: 900,
    },
  };
});

export default StyledAgGridReact;
